import React from "react";
import { Info, X } from "lucide-react";

import {
    getModuleCleContentTypeLabel,
    getUnlockRuleSummary,
} from "../moduleCleContentHelpers";

export default function ModuleCleContentDetailsPanel({ open, content, onClose }) {
    if (!content) return null;

    return (
        <aside className={`mcp-panel ${open ? "is-open" : ""}`}>
            <header className="mcp-panel__header">
                <h2>
                    <Info size={18} />
                    Détails du contenu
                </h2>
                <button type="button" className="mcp-icon-btn" onClick={onClose}>
                    <X size={20} />
                </button>
            </header>

            <div className="mcp-panel__body">
                <section className="mcp-form-section">
                    <div className="mcp-form-section__title">Informations principales</div>
                    <div className="mcp-field">
                        <label>Titre</label>
                        <div className="mcp-read-only">{content.title}</div>
                    </div>
                    <div className="mcp-field">
                        <label>Description</label>
                        <div className="mcp-read-only">{content.description || "Aucune description fournie."}</div>
                    </div>
                    <div className="mcp-field-group">
                        <div className="mcp-field">
                            <label>Type</label>
                            <div className="mcp-read-only">{getModuleCleContentTypeLabel(content.contentType)}</div>
                        </div>
                        <div className="mcp-field">
                            <label>Section</label>
                            <div className="mcp-read-only">#{content.sectionId}</div>
                        </div>
                    </div>
                </section>

                <section className="mcp-form-section">
                    <div className="mcp-form-section__title">Paramètres avancés</div>
                    <div className="mcp-field-group">
                        <div className="mcp-field">
                            <label>Statut</label>
                            <span className={`mcp-badge ${content.active ? "mcp-badge--active" : "mcp-badge--inactive"}`}>
                                {content.active ? "ACTIF" : "INACTIF"}
                            </span>
                        </div>
                        <div className="mcp-field">
                            <label>Visibilité</label>
                            <span className={`mcp-badge ${content.visible ? "mcp-badge--active" : "mcp-badge--inactive"}`}>
                                {content.visible ? "VISIBLE" : "MASQUÉ"}
                            </span>
                        </div>
                    </div>
                    <div className="mcp-field">
                        <label>Condition de déblocage</label>
                        <div className="mcp-read-only">{getUnlockRuleSummary(content)}</div>
                    </div>
                </section>

                <section className="mcp-form-section">
                    <div className="mcp-form-section__title">Fichiers & Source</div>
                    <div className="mcp-field">
                        <label>Nom du fichier</label>
                        <div className="mcp-read-only">{content.fileName || "N/A (Lien ou Article)"}</div>
                    </div>
                    {content.externalUrl && (
                        <div className="mcp-field">
                            <label>URL externe</label>
                            <a href={content.externalUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: "13px", color: "var(--mcp-blue)", fontWeight: "600" }}>
                                {content.externalUrl}
                            </a>
                        </div>
                    )}
                </section>
            </div>

            <footer className="mcp-panel__footer">
                <button type="button" className="mcp-btn mcp-btn--primary" onClick={onClose}>
                    Fermer
                </button>
            </footer>
        </aside>
    );
}
